import { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import LocationsDrawer from 'components/Locations/Drawer/Drawer';
import LocationsList from 'components/Locations/List/List';
import LocationDetails from 'components/Locations/Details/Details';
import useCustomSelector from 'hooks/useCustomSelector';
import { locationsSelectors } from 'features/locations';

const Locations = () => {
  const { id } = useCustomSelector(locationsSelectors.getLocationData);
  
  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <LocationsDrawer />
      <LocationsList />
      {!!!id ? <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant='h5'>Please select a location...</Typography>
      </Box> :  <LocationDetails /> } 
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Locations {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);